import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import BoardForm from "componentsv2/form/BoardForm";
import layoutSale from "../models/ModelSale";
import { genStoreId } from "componentsv2/tools/functions";

const Sale = ({ onChangeView }) => {
  const currentView = useSignal("list");
  const recordStoreId = useSignal(null);
  const _layoutSale = layoutSale();

  function handleView(action, recStoreId) {
    if (action === "add") {
      currentView.value = "form";
      recordStoreId.value = genStoreId(_layoutSale.model, null);
    } else if (action === "return") {
      currentView.value = "list";
    } else if (action === "edit") {
      currentView.value = "form";
      recordStoreId.value = recStoreId;
    } else {
      currentView.value = "list";
      recordStoreId.value = null;
    }
    if (onChangeView) onChangeView(action);
  }

  return (
    <div className="w-full h-full">
      {currentView.value === "form" ? (
        <BoardForm
          layout={_layoutSale}
          storeId={recordStoreId.value}
          handleView={handleView}
          title={true}
          closeOnChangeView
        />
      ) : (
        <Board
          layout={_layoutSale}
          currentView={currentView}
          recordStoreId={recordStoreId}
          handleView={handleView}
          setView={currentView}
        />
      )}
    </div>
  );
};

export default Sale;
